export default {
  data() {
    return {
      mapOptions: {},
    };
  },

  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      this.setMapOptions();
    });
  },

  methods: {
    setMapOptions() {
      this.mapOptions = {
        scrollwheel: false,
        draggable: true,
        gestureHandling: 'greedy',
        mapTypeControl: false,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.TOP_CENTER,
        },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        scaleControl: false,
        streetViewControl: false,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        fullscreenControl: false,
        styles: [
          {
            featureType: 'landscape.natural',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                color: '#e0efef',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                hue: '#1900ff',
              },
              {
                color: '#c0e8e8',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              {
                lightness: 100,
              },
              {
                visibility: 'simplified',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'on',
              },
              {
                lightness: 700,
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'all',
            stylers: [
              {
                color: '#7dcdcd',
              },
            ],
          },
        ],
      };
    },
  },
};
